












































































import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import Evaluation from '@/evaluations/entities/evaluation'

@Component
export default class PreviewDialog extends Vue {
  @Ref()
  protected validator!: ValidationObserver

  private dialog: boolean = false
  private evaluationId = ''
  private emailSender = ''
  private emailRecipient = ''
  private message = ''

  public open(evaluation: Evaluation) {
    this.evaluationId = evaluation.id
    this.emailSender = evaluation.moderatorEmail
    this.dialog = true
  }

  private async confirm() {
    if (await this.validator.validate()) {
      this.$emit(
        'confirm',
        this.emailSender,
        this.emailRecipient,
        this.message,
        this.evaluationId
      )
      this.dialog = false
    }
  }

  private cancel() {
    this.$emit('cancel')
    this.dialog = false
  }
}
